import { useNavigate } from "react-router"
import { useReduxDispatch } from "@/store/useReduxDispatch"
import { getIsAdmin, logOut } from "@/services/authService"
import { useSelector } from "react-redux"
import { wishSelectors } from "@/slices/wishSlice"
import { FloatingBoxes } from "@/components/layout/FloatingBoxes"
import { WishBox } from "@/components/wish/WishBox"
import "./homePage.scss"
import { useState } from "react"
import { changeWishSortingThunk } from "@/thunks/wishThunks"
import { sortAscending } from "@/utils/arrayUtils"
import { BasePage } from "@/components/layout/BasePage"
import { settingsActions, settingsSelectors } from "@/slices/settingsSlice"

const HomePage = (): JSX.Element => {
  const dispatch = useReduxDispatch()
  const navigate = useNavigate()

  const wishlists = useSelector(wishSelectors.wishLists)
  const settings = useSelector(settingsSelectors.settings)
  const adminShowRegistrations = useSelector(settingsSelectors.adminShowRegistrations)

  const [showAll, setShowAll] = useState(false)
  const wishes = sortAscending(
    (wishlists ?? [])
      .filter((wl) => showAll || settings?.showOwners.includes(wl.owner))
      .map((w) => w.wishes)
      .flat() ?? [],
    (w) => w.sort
  ).filter((w) => showAll || !w.isHidden)
  const [sort, setSort] = useState(false)

  return (
    <BasePage
      className="home-page"
      title={
        settings?.themeType === "christmas"
          ? "Ønskeliste"
          : settings?.themeType === "marinaBirthday"
            ? "Marinas ønskeliste"
            : "Christians ønskeliste"
      }
      showHeaderImages
    >
      <div>
        {getIsAdmin() && (
          <div className="home-page__admin">
            <h3>Admin</h3> <button onClick={() => navigate("/editWish")}>Tilføj ønske</button>
            <button onClick={() => navigate("/admin")}>Indstillinger</button>
            <button onClick={() => setSort(!sort)}>
              {sort ? "Slå sortering fra" : "Slå sortering til"}
            </button>
            <button onClick={() => setShowAll(!showAll)}>
              {showAll ? "Vis aktive ønsker" : "Vis alle ønsker"}
            </button>
            <button
              onClick={() =>
                dispatch(
                  settingsActions.setAdminShowRegistrations(!(adminShowRegistrations ?? false))
                )
              }
            >
              {adminShowRegistrations ? "Skjul registreringer" : "Vis registreringer"}
            </button>
            <button
              onClick={() => {
                logOut()
              }}
            >
              Log out
            </button>
          </div>
        )}
        <div className="home-page__wish-list">
          <FloatingBoxes
            minWidth={250}
            spacing={6}
            items={wishes}
            renderBox={(w) => (
              <WishBox
                canClick={!!getIsAdmin()}
                wish={w}
                key={w.id}
                onClick={() => {
                  if (getIsAdmin()) {
                    navigate("editWish/" + w.id)
                  }
                }}
              />
            )}
            isSortable={sort}
            onSortChange={async (fromIndex, toIndex) => {
              if (fromIndex === toIndex) {
                return
              }
              const item = wishes[fromIndex]
              const indexModifier = fromIndex > toIndex ? -1 : 0
              const afterItem = toIndex === 0 ? undefined : wishes[toIndex + indexModifier]
              const beforeItem =
                toIndex === wishes.length ? undefined : wishes[toIndex + indexModifier + 1]
              await dispatch(changeWishSortingThunk(item.id, afterItem?.id, beforeItem?.id))
            }}
          />
        </div>
      </div>
    </BasePage>
  )
}

export default HomePage
